module.exports = __webpack_public_path__ + "static/media/Seperated Straight Away.04478c06.png";